import { SelectItemWithDescription } from '@/types/fields';

export const indiaPurposeOfTransferOptions: ReadonlyArray<SelectItemWithDescription> = [
  // Group 00 - Capital Account
  {
    value: 'P0001',
    label: 'Repatriation of Indian investment abroad in equity capital',
    description: 'Repatriation of Indian investment abroad in equity capital (shares)',
  },
  {
    value: 'P0002',
    label: 'Repatriation of Indian investment abroad in debt securities',
    description: 'Repatriation of Indian investment abroad in debt securities',
  },
  {
    value: 'P0003',
    label: 'Repatriation of Indian investment abroad in branches',
    description: 'Repatriation of Indian investment abroad in branches',
  },
  {
    value: 'P0004',
    label: 'Repatriation of Indian investment abroad in subsidiaries',
    description: 'Repatriation of Indian investment abroad in subsidiaries and associates',
  },
  {
    value: 'P0005',
    label: 'Repatriation of Indian investment abroad in real estate',
    description: 'Repatriation of Indian investment abroad in real estate',
  },
  {
    value: 'P0006',
    label: 'Foreign direct investment in India in equity',
    description: 'Foreign direct investment in India in equity',
  },
  {
    value: 'P0007',
    label: 'Foreign direct investment in India in debt securities',
    description: 'Foreign direct investment in India in debt securities',
  },
  {
    value: 'P0008',
    label: 'Foreign direct investment in India in real estate',
    description: 'Foreign direct investment in India in real estate',
  },
  {
    value: 'P0009',
    label: 'Foreign portfolio investment in India in equity shares',
    description: 'Foreign portfolio investment in India in equity shares',
  },
  {
    value: 'P0010',
    label: 'Foreign portfolio investment in India in debt securities',
    description: 'Foreign portfolio investment in India in debt securities including debt funds',
  },
  {
    value: 'P0011',
    label: 'Repayment of loans extended to non-residents',
    description: 'Repayment of loans extended to non-residents',
  },
  {
    value: 'P0012',
    label: 'Loans from non-residents to India',
    description: 'Loans from non-residents to India',
  },
  {
    value: 'P0014',
    label: 'Receipts on non-resident deposits',
    description:
      'Receipts on or about non-resident deposits (FCNRB/NRERA etc.). Authorised dealers should report these even if funds are not swapped into rupees',
  },
  {
    value: 'P0015',
    label: 'Loans & overdrafts taken by authorised dealers',
    description:
      'Loans & overdrafts taken by authorised dealers on their own account. (Any amount of loan credited to the nostro account which may not be swapped into rupees should also be reported)',
  },
  {
    value: 'P0016',
    label: 'Purchase of a foreign currency against another currency',
    description: 'Purchase of a foreign currency against another currency',
  },
  {
    value: 'P0017',
    label: 'Sale of intangible assets',
    description:
      'Sale of intangible assets like patents, copyrights, trademarks etc. by Indian companies',
  },
  {
    value: 'P0018',
    label: 'Other capital receipts not included elsewhere',
    description: 'Other capital receipts not included elsewhere',
  },

  // Group 01 - Exports (of Goods)
  {
    value: 'P0101',
    label: 'Value of export bills negotiated/purchased',
    description:
      'Value of export bills negotiated / purchased / discounted etc. (covered under GR/PP/SOFTEX/EC copy of shipping bills etc.)',
  },
  {
    value: 'P0102',
    label: 'Realisation of export bills sent on collection',
    description:
      'Realisation of export bills (in respect of goods) sent on collection (full invoice value)',
  },
  {
    value: 'P0103',
    label: 'Advance receipts against export contracts',
    description: 'Advance receipts against export contracts (export of goods only)',
  },
  {
    value: 'P0104',
    label: 'Receipts against export of goods not covered by GR/PP/SOFTEX',
    description:
      'Receipts against export of goods not covered by the GR/PP/SOFTEX/EC copy of shipping bill etc.',
  },
  {
    value: 'P0105',
    label: 'Export bills sent on collection',
    description: 'Export bills (in respect of goods) sent on collection',
  },
  {
    value: 'P0106',
    label: 'Conversion of overdue export bills from NPD to collection',
    description: 'Conversion of overdue export bills from NPD to collection mode',
  },
  {
    value: 'P0107',
    label: 'Realisation of NPD export bills',
    description: 'Realisation of NPD export bills (full value of bill to be reported)',
  },

  // Group 02 - Transportation
  {
    value: 'P0201',
    label: 'Receipts by Indian shipping companies operating abroad',
    description:
      'Receipts of surplus freight/passenger fare by Indian shipping companies operating abroad',
  },
  {
    value: 'P0202',
    label: 'Operating expenses of foreign shipping companies in India',
    description:
      'Purchases, on account of operating expenses of foreign shipping companies operating in India',
  },
  {
    value: 'P0205',
    label: 'Operational leasing (with crew) - shipping',
    description: 'Purchases on account of operational leasing (with crew) – shipping companies',
  },
  {
    value: 'P0207',
    label: 'Receipts by Indian airlines companies operating abroad',
    description:
      'Receipts of surplus freight/passenger fare by Indian airlines companies operating abroad',
  },
  {
    value: 'P0208',
    label: 'Operating expenses of foreign airlines companies in India',
    description:
      'Receipt on account of operating expenses of foreign airlines companies operating in India',
  },
  {
    value: 'P0211',
    label: 'Operational leasing (with crew) - airlines',
    description: 'Purchases on account of operational leasing (with crew) – airlines companies',
  },
  {
    value: 'P0213',
    label: 'Other transportation services',
    description:
      'Receipts on account of other transportation services (stevedoring, demurrage, port handling charges etc.)',
  },

  // Group 03 - Travel
  {
    value: 'P0301',
    label: 'Purchases towards travel',
    description:
      'Purchases towards travel (includes purchases of foreign travellers cheques, currency: notes etc over the counter, by hotels, hospitals, emporiums, educational institutions etc. as well as amount received by Swift/telegraphic transfers (TT) or debit',
  },
  {
    value: 'P0308',
    label: 'Foreign currencies surrendered by returning Indian tourists',
    description: 'Foreign currencies surrendered by returning Indian tourists',
  },

  // Group 04 - Communication Service
  {
    value: 'P0401',
    label: 'Postal services',
    description: 'Postal services',
  },
  {
    value: 'P0402',
    label: 'Courier services',
    description: 'Courier services',
  },
  {
    value: 'P0403',
    label: 'Telecommunication services',
    description: 'Telecommunication services',
  },
  {
    value: 'P0404',
    label: 'Satellite services',
    description: 'Satellite services',
  },

  // Group 05 - Construction Service
  {
    value: 'P0501',
    label: 'Receipts for construction of services projects in India',
    description: 'Receipts for cost of construction of services projects in India',
  },

  // Group 06 - Insurance Service
  {
    value: 'P0601',
    label: 'Life insurance premium receipts',
    description: 'Receipts of life insurance premium',
  },
  {
    value: 'P0602',
    label: 'Freight insurance receipts',
    description: 'Receipts of freight insurance – relating to import & export of goods',
  },
  {
    value: 'P0603',
    label: 'Other general insurance premium receipts',
    description: 'Receipts on account of other general insurance premium',
  },
  {
    value: 'P0604',
    label: 'Reinsurance premium receipts',
    description: 'Receipts of reinsurance premium',
  },
  {
    value: 'P0605',
    label: 'Auxiliary services receipts',
    description: 'Receipts on account of auxiliary services (commission on insurance)',
  },
  {
    value: 'P0606',
    label: 'Settlement of claims receipts',
    description: 'Receipts on account of settlement of claims',
  },

  // Group 07 - Financial Services
  {
    value: 'P0701',
    label: 'Financial intermediation services',
    description:
      'Financial intermediation except investment banking – bank charges, collection charges, letter of credit (LC) charges, cancellation of forward contracts, commission on financial leasing etc.',
  },
  {
    value: 'P0702',
    label: 'Investment banking services',
    description: 'Investment banking – brokerage, underwriting commission etc.',
  },
  {
    value: 'P0703',
    label: 'Auxiliary financial services',
    description:
      'Auxiliary services – charges on operation & regulatory fees, custodial services, depository services etc.',
  },

  // Group 08 - Computer & Info. Services
  {
    value: 'P0801',
    label: 'Hardware consultancy',
    description: 'Hardware consultancy',
  },
  {
    value: 'P0802',
    label: 'Software implementation/consultancy',
    description: 'Software implementation/consultancy (other than those covered in SOFTEX form)',
  },
  {
    value: 'P0803',
    label: 'Database, data processing charges',
    description: 'Database, data processing charges',
  },
  {
    value: 'P0804',
    label: 'Repair and maintenance of computer and software',
    description: 'Repair and maintenance of computer and software',
  },
  {
    value: 'P0805',
    label: 'News agency services',
    description: 'News agency services',
  },
  {
    value: 'P0806',
    label: 'Other information services',
    description: 'Other information services-subscription to newspapers, periodicals etc.',
  },

  // Group 09 - Royalties & License Fees
  {
    value: 'P0901',
    label: 'Franchises services',
    description:
      'Franchises services – patents, copyrights, trademarks, industrial processes, franchises etc.',
  },
  {
    value: 'P0902',
    label: 'Receipts for licensing arrangements',
    description:
      'Receipts for use, through licensing arrangements, of produced originals or prototypes (such as manuscripts and films)',
  },

  // Group 10 - Other Business Services
  {
    value: 'P1001',
    label: 'Merchanting Services',
    description:
      'Merchanting Services – net receipts (from sale and purchase of goods without crossing the border)',
  },
  {
    value: 'P1002',
    label: 'Trade-related services',
    description: 'Trade-related services – commission on exports/imports',
  },
  {
    value: 'P1003',
    label: 'Operational leasing services',
    description:
      'Operational leasing services (other than financial leasing and without operating crew) including charter hire',
  },
  {
    value: 'P1004',
    label: 'Legal services',
    description: 'Legal services',
  },
  {
    value: 'P1005',
    label: 'Accounting, auditing, bookkeeping and tax consultancy',
    description: 'Accounting, auditing, bookkeeping and tax consultancy services',
  },
  {
    value: 'P1006',
    label: 'Business and management consultancy',
    description: 'Business and management consultancy and public relations services',
  },
  {
    value: 'P1007',
    label: 'Advertising and market research services',
    description: 'Advertising, trade fair, market research and public opinion polling services',
  },
  {
    value: 'P1008',
    label: 'Research & development services',
    description: 'Research & development services',
  },
  {
    value: 'P1009',
    label: 'Architectural, engineering and technical services',
    description: 'Architectural, engineering and other technical services',
  },
  {
    value: 'P1010',
    label: 'Agricultural, mining and on-site processing services',
    description:
      'Agricultural, mining and on-site processing services – protection against insects & disease, increasing of harvest yields, forestry services, mining services like analysis of ores etc.',
  },
  {
    value: 'P1011',
    label: 'Maintenance of offices in India',
    description: 'Inward remittance for maintenance of offices in India',
  },
  {
    value: 'P1012',
    label: 'Distribution services',
    description: 'Distribution services',
  },
  {
    value: 'P1013',
    label: 'Environmental services',
    description: 'Environmental services',
  },
  {
    value: 'P1019',
    label: 'Other services not included elsewhere',
    description: 'Other services not included elsewhere',
  },

  // Group 11 - Personal, Cultural & Recreational Services
  {
    value: 'P1101',
    label: 'Audio-visual and related services',
    description:
      'Audio-visual and related services -services and associated fees related to production of motion pictures, rentals, fees received by actors, directors, producers and fees for distribution rights',
  },
  {
    value: 'P1102',
    label: 'Personal and cultural services',
    description:
      'Personal, cultural services such as those related to museums, libraries, archives and sporting activities and fees for correspondence courses of Indian Universities/Institutes',
  },

  // Group 12 - Government, not included elsewhere
  {
    value: 'P1201',
    label: 'Maintenance of foreign embassies in India',
    description: 'Maintenance of foreign embassies in India',
  },
  {
    value: 'P1203',
    label: 'Maintenance of international institutions in India',
    description:
      'Maintenance of international institutions such as offices of IMF mission, World Bank, UNICEF etc. in India',
  },

  // Group 13 - Transfers
  {
    value: 'P1301',
    label: 'Family maintenance and savings',
    description:
      'Inward remittance from Indian non-residents towards family maintenance and savings',
  },
  {
    value: 'P1302',
    label: 'Personal gifts and donations',
    description: 'Personal gifts and donations',
  },
  {
    value: 'P1303',
    label: 'Donations to religious and charitable institutions',
    description: 'Donations to religious and charitable institutions in India',
  },
  {
    value: 'P1304',
    label: 'Grants and donations to governments',
    description:
      'Grants and donations to governments and charitable institutions established by the governments',
  },
  {
    value: 'P1306',
    label: 'Receipts/refund of taxes',
    description: 'Receipts/refund of taxes',
  },

  // Group 14 - Income
  {
    value: 'P1401',
    label: 'Compensation of employees',
    description: 'Compensation of employees',
  },
  {
    value: 'P1403',
    label: 'Interest on loans extended to non-residents',
    description:
      'Inward remittance towards interest on loans extended to non-residents (ST/MT/LT loans)',
  },
  {
    value: 'P1404',
    label: 'Interest on debt securities',
    description: 'Inward remittance of interest on debt securities – debentures/bonds/FRNs etc.',
  },
  {
    value: 'P1405',
    label: 'Interest receipts of Authorised dealers',
    description:
      'Inward remittance towards interest receipts of Authorised dealers on their own account (on investments)',
  },
  {
    value: 'P1406',
    label: 'Repatriation of profits to India',
    description: 'Repatriation of profits to India',
  },
  {
    value: 'P1407',
    label: 'Receipt of dividends by Indians',
    description: 'Receipt of dividends by Indians',
  },

  // Group 15 - Others
  {
    value: 'P1501',
    label: 'Refunds/rebates on account of imports',
    description: 'Refunds / rebates on account of imports',
  },
  {
    value: 'P1502',
    label: 'Reversal of incorrect entries',
    description: 'Reversal of incorrect entries, refunds of amount remitted for non-imports',
  },
  {
    value: 'P1503',
    label: 'Remittances under international bidding process',
    description: 'Remittances (receipts) by residents under international bidding process',
  },
  {
    value: 'P1590',
    label: 'Receipts below $10,000',
    description: 'Receipts below $10,000 (say Rs 5,00,000)',
  },
];
